import { render } from "./page-login.vue?vue&type=template&id=56500c97&scoped=true"
import script from "./page-login.vue?vue&type=script&lang=js"
export * from "./page-login.vue?vue&type=script&lang=js"

import "./page-login.vue?vue&type=style&index=0&id=56500c97&scoped=true&lang=css"

import exportComponent from "D:\\Accen_GITS\\Gestion-conge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56500c97"]])

export default __exports__